import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const inti_state = {
  data: {},
  loading: true,
};

export const fetchFnbPriceHistory = createAsyncThunk(
  "fnb/price history",
  async (id, thunkApi) => {
    try {
      const { user } = thunkApi.extra.apiService;
      const response = await user.get(`/fnbproduct/price-history/${id}`);
      return response;
    } catch (error) {
      return new Promise.reject(error);
    }
  }
);

const priceHistorySlice = createSlice({
  name: "price history",
  initialState: inti_state,
  extraReducers: (builder) => {
    builder
      .addCase(fetchFnbPriceHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFnbPriceHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchFnbPriceHistory.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default priceHistorySlice.reducer;
